// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1CompanySchema } from './v1/companySchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const get11AccountIdClientsIdPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the client you want to retrieve"),
  id: z.number().int().describe("Client ID to retrieve"),
});

export const get11AccountIdClientsIdQueryParamsSchema = z.object({
  project_counts: z.optional(z.coerce.string().describe("Specify to retrieve project counts. Example values: \"true\" or \"false\"")),
}).optional();

export const get11AccountIdClientsIdHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Client details
 */
export const get11AccountIdClientsId200Schema = z.lazy(() => v1CompanySchema);

/**
 * @description Client not found
 */
export const get11AccountIdClientsId404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const get11AccountIdClientsIdQueryResponseSchema = z.lazy(() => get11AccountIdClientsId200Schema);
